<div class="c-form-field c-form-field--search">
  <label class="c-form-field__inner">
    <input
      [ngModel]="value"
      (keydown)="onKeydownSearch($event)"
      type="text"
      class="c-form-field__input"
      i18n-placeholder="@@common.search_by_id_"
      placeholder="Search by ID..."
      #searchInput
    />
    <p500-ui-icon name="search c-form-field__icon" (click)="searchByString(searchInput.value)" style="cursor: pointer"></p500-ui-icon>
  </label>
</div>
